export const BUSINESS = {
  name: "Do jaja",
  address: "Kneza Miloša bb, Kragujevac",
  since: 2000,
  phones: [
    { label: "034/331-588", tel: "+38134331588" },
    { label: "064/1528228", tel: "+381641528228" },
  ],
  hours: [
    { days: "Ponedeljak – Četvrtak", time: "08:00 – 03:00" },
    { days: "Petak – Subota", time: "08:00 – 05:00" },
    { days: "Nedelja", time: "14:00 – 00:00" },
  ],
  glovo: "https://glovoapp.com/sr/rs/kragujevac/stores/fast-food-do-jaja-krg",
  wolt: "https://wolt.com/sr/srb/kragujevac/restaurant/do-jaja",
  mapsEmbed:
    "https://maps.google.com/maps?q=Kneza%20Milo%C5%A1a%20bb%2C%20Kragujevac%2C%20Serbia&z=16&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/Do+jaja+Kneza+Milo%C5%A1a+Kragujevac",
};
